import { createYouTubeVideos } from "./video.youtube";
import { isMobile } from "./utilities";

document.addEventListener("DOMContentLoaded", () => {
    const videoCardsSection = document.querySelector(".video-cards");
    if (!videoCardsSection) return;

    const videoCardsSections = document.querySelectorAll(".video-cards");

    const handleVideoCards = function (videoCardSection) {
        const videoCards = videoCardSection.querySelectorAll(".video-card");
        const videoCardsList = videoCardSection.querySelector(".video-cards__list");
        const hiddenVideoCards = [...document.querySelectorAll(".video-card.hidden")];

        function getVideoCardsListPosition() {
            const videoCardsListPosition = videoCardsList.getBoundingClientRect().top + window.scrollY - 70;
            return videoCardsListPosition;
        }

        videoCards.forEach((card) => {
            const content = card.querySelector(".video-card__content");
            const arrow = card.querySelector(".video-card__arrow");
            const text = card.querySelector(".video-card__text");

            arrow.addEventListener("click", function () {
                if (content.classList.contains("open")) {
                    window.scrollTo(0, getVideoCardsListPosition());
                }

                text.classList.toggle("hidden");
                content.classList.toggle("open");
            });

            card.addEventListener("click", function () {
                card.classList.add("video-card--expanded");
                card.classList.add("video-playing");
                card.classList.add("video--focused");

                window.scrollTo(0, getVideoCardsListPosition());

                videoCards.forEach((card) => {
                    if (card === this) {
                        return;
                    } else {
                        if (!card.classList.contains("hidden")) {
                            card.classList.remove("video-card--expanded");
                            card.classList.remove("video-playing");
                            card.classList.remove("video--focused");
                            card.querySelector(".video-card__content").classList.remove("open");
                            card.querySelector(".video-card__text").classList.add("hidden");
                        }
                    }
                });
            });
        });

        const playButtons = videoCardSection.querySelectorAll(".js-play-btn");
        playButtons.forEach((button) => {
            button.addEventListener("click", () => {
                const card = button.closest(".video-card");
                card.classList.add("video-playing");
                card.classList.add("video-card--expanded");
            });
        });

        const showMoreButton = videoCardSection.querySelector(".video-cards__show-more");
        showMoreButton && showMoreButton.addEventListener("click", showMoreCards);

        const filterOptions = videoCardSection.querySelectorAll(".video-cards .custom-option");
        filterOptions.forEach((option) => option.addEventListener("click", filterCards));

        function setMediaSrc(cardArr) {
            cardArr.forEach((card) => {
                const videoEl = card.querySelector(".video-card__video");
                const vidSrc = videoEl.dataset.source;
                vidSrc && (videoEl.dataset.vidId = vidSrc);
            });
        }

        function showMoreCards() {
            let i = 0;
            const nextCardSet = hiddenVideoCards.filter((card) => {
                if (i < 5 && card.classList.contains("hidden")) {
                    i++;
                    return card;
                }
            });

            setMediaSrc(nextCardSet);

            const nextVideoSet = getVideosToCreate(nextCardSet);
            createYouTubeVideos(nextVideoSet);

            nextCardSet.forEach((card) => displayCard(card));

            const hasHiddenCards = hiddenVideoCards.some((card) => card.classList.contains("hidden"));
            !hasHiddenCards && showMoreButton.classList.add("hidden");
        }

        function getVideosToCreate(cardsArr) {
            const videoCardsWithSource = cardsArr.filter((card) => card.querySelector(".video-card__video").dataset.source);
            return videoCardsWithSource && videoCardsWithSource.map((card) => card.querySelector(".video-card__video"));
        }

        function displayCard(card) {
            card.classList.remove("hidden");
        }

        function filterCards() {
            const selectedCategory = this.dataset.value;
            let selectedVideoCards;

            if (selectedCategory == "all") {
                selectedVideoCards = [...videoCards];
            } else {
                selectedVideoCards = [...videoCards].filter((card) => card.dataset.filter === selectedCategory);
            }

            const videosToCreate = getVideosToCreate(selectedVideoCards);

            setMediaSrc(selectedVideoCards);
            createYouTubeVideos(videosToCreate);

            videoCards.forEach((card) => {
                card.classList.remove("video-playing");
                card.querySelector(".video-card__content").classList.remove("open");
                card.querySelector(".video-card__text").classList.add("hidden");

                if (!selectedCategory == "all" || !card.dataset.filter.includes(selectedCategory)) {
                    card.classList.add("hidden");
                } else {
                    displayCard(card);
                    card.classList.remove("video-card--expanded");
                }
            });

            if (selectedCategory == "all") {
                videoCards.forEach((card, i) => {
                    card.classList.remove("hidden");

                    if (card.classList.contains("featured")) {
                        card.classList.add("video-card--expanded");
                    } else {
                        card.classList.remove("video-card--expanded");
                    }
                });
            } else {
                videoCardSection.querySelector(".video-card:not(.hidden)").classList.add("video-card--expanded");
            }

            window.scrollTo(0, getVideoCardsListPosition());

            showMoreButton.setAttribute("hidden", true);

            videoCardSection.querySelectorAll("details").forEach((detail) => detail.removeAttribute("open"));

            if (!isMobile()) {
                const visibleCards = videoCardSection.querySelectorAll(".video-card:not(.hidden)");
                const isNumberOfVisibleCardsEven = visibleCards.length % 2 == 0;

                if (isNumberOfVisibleCardsEven) {
                    const expandedCards = videoCardSection.querySelectorAll(".video-card--expanded");
                    expandedCards.forEach((card) => card.classList.remove("video-card--expanded"));
                }
            }
        }
    };

    videoCardsSections.forEach((section) => {
        handleVideoCards(section);
    });
});
